module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "sec-4"
    }
  }, [_c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-top": "3em",
      "margin-bottom": "0.1em"
    },
    attrs: {
      "id": "pz4-6"
    }
  }, [_c('b', [_vm._v("INTERGENERATE")])]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "A5x"
    }
  }, [_c('i', [_vm._v("Transforming Churches through Intergenerational Ministry")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "ARR"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-4-1.png",
      "id": "Ane0",
      "src": "images/himg-4-1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "id": "AO0"
    }
  }, [_vm._v("\n\t\t\t\t\tCopyright © 2018 by Holly Catterton Allen ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "A6Q"
    }
  }, [_vm._v("\n\t\t\t\t\tISBN 978-1-68426-150-5 | LCCN 2018015666 ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "AVUA"
    }
  }, [_vm._v("\n\t\t\t\t\tPrinted in the United States of America ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-bottom": "0em"
    },
    attrs: {
      "id": "A66T"
    }
  }, [_vm._v("\n\t\t\t\t\tALL RIGHTS RESERVED ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "pz4-7"
    }
  }, [_vm._v("\n\t\t\t\t\tNo part of this publication may be reproduced, stored in a retrieval system, or transmitted\n\t\t\t\t\tin any form by any means—electronic, mechanical, photocopying, recording, or otherwise—without\n\t\t\t\t\tprior written consent. ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "pz4-8"
    }
  }, [_vm._v("\n\t\t\t\t\tAll Scripture quotations, unless otherwise indicated, are taken from the Holy Bible,\n\t\t\t\t\tNew International Version"), _c('sup', [_vm._v("®")]), _vm._v(", NIV"), _c('sup', [_vm._v("®")]), _vm._v(". Copyright © 1973, 1978, 1984, 2011 by Biblica,\n\t\t\t\t\tInc.™ Used by permission of Zondervan. All rights reserved worldwide. ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "pz4-9"
    }
  }, [_vm._v("\n\t\t\t\t\tScripture quotations noted "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("nrsv")]), _vm._v(" are taken from the New Revised Standard Version Bible,\n\t\t\t\t\tcopyright © 1989, the Division of Christian Education of the National Council of\n\t\t\t\t\tthe Churches of Christ in the United States of America. Used by permission. All rights\n\t\t\t\t\treserved. ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "pz4-10"
    }
  }, [_vm._v("\n\t\t\t\t\tINTERGENERATE ™ is a registered trademark of Lipscomb University, used under permission\n\t\t\t\t\tof Lipscomb University. All rights reserved. ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "pz4-11"
    }
  }, [_vm._v("\n\t\t\t\t\tPhotographs on pages 242–43 are in the public domain and have been provided by Vibrant\n\t\t\t\t\tFaith from the Visual Faith Project. ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "pz4-12"
    }
  }, [_vm._v("\n\t\t\t\t\tParts of Chapter Two are drawn from a previous publication: Gareth Crispin. “A Theology\n\t\t\t\t\tof Accommodation as a Resource for Integrating Youth and Children into Intergenerational\n\t\t\t\t\tChurch” from "), _c('i', [_vm._v("Christian Education Journal")]), _vm._v(". Copyright © 2017 by "), _c('i', [_vm._v("Christian Education\n\t\t\t\t\tJournal")]), _vm._v(". Reprinted by permission of "), _c('i', [_vm._v("Christian Education Journal")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    staticStyle: {
      "padding-bottom": "1em",
      "margin-bottom": "0.4em",
      "border-bottom": "solid 1px #000000"
    },
    attrs: {
      "id": "pz4-13"
    }
  }, [_vm._v("\n\t\t\t\t\tParts of Chapter Fourteen are drawn from a previous publication: Holly C. Allen.\n\t\t\t\t\t\"Walking with Emerging Adults on the Spiritual Journey\" from "), _c('i', [_vm._v("A Faith for the Generations")]), _vm._v(".\n\t\t\t\t\tCopyright © 2015 by Timothy W. Herrmann, Kirsten D. TenHaken, Hannah M. Adderley,\n\t\t\t\t\tand Morgan K. Morris. Reprinted by permission of Abilene Christian University Press.\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-bottom": "0em"
    },
    attrs: {
      "id": "AHq"
    }
  }, [_vm._v("\n\t\t\t\t\tLIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-bottom": "0em"
    },
    attrs: {
      "id": "APz"
    }
  }, [_vm._v("\n\t\t\t\t\tNames: Allen, Holly Catterton, editor. ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-bottom": "0em"
    },
    attrs: {
      "id": "ASJ"
    }
  }, [_vm._v("\n\t\t\t\t\tTitle: Intergenerate : transforming churches through intergenerational ministry /\n\t\t\t\t\tedited by Holly Catterton Allen. ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-bottom": "0em"
    },
    attrs: {
      "id": "A72"
    }
  }, [_vm._v("\n\t\t\t\t\tDescription: Abilene : Abilene Christian University Press, 2018. ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-bottom": "0em"
    },
    attrs: {
      "id": "AGI"
    }
  }, [_vm._v("\n\t\t\t\t\tIdentifiers: LCCN 2018015666 | ISBN 9781684261505 (pbk.) ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-bottom": "0em"
    },
    attrs: {
      "id": "ADB"
    }
  }, [_vm._v("\n\t\t\t\t\tSubjects: LCSH: Church. | Intergenerational relations—Religious aspects—Christianity.\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-bottom": "0em"
    },
    attrs: {
      "id": "AlR"
    }
  }, [_vm._v("\n\t\t\t\t\tClassification: LCC BV640 .I58 2018 | DDC 253—dc23 ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    staticStyle: {
      "padding-bottom": "0.2em",
      "margin-bottom": "1.5em",
      "border-bottom": "solid 1px #000000"
    },
    attrs: {
      "id": "AY5z"
    }
  }, [_vm._v("\n\t\t\t\t\tLC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/",
      "id": "A4mR",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/")]), _vm._v(" 2018015666 ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "pz4-15"
    }
  }, [_vm._v("\n\t\t\t\t\tCover design by ThinkPen Design | Interior text design by Sandy Armstrong, Strong\n\t\t\t\t\tDesign ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-bottom": "0em"
    },
    attrs: {
      "id": "pz4-16"
    }
  }, [_vm._v("\n\t\t\t\t\tFor information contact: ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-bottom": "0em"
    },
    attrs: {
      "id": "pz4-17"
    }
  }, [_vm._v("\n\t\t\t\t\tAbilene Christian University Press ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "pz4-18"
    }
  }, [_vm._v("\n\t\t\t\t\tACU Box 29138, Abilene, Texas 79699 ")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "pz4-19"
    }
  }, [_vm._v("\n\t\t\t\t\t1-877-816-4455 | "), _c('a', {
    attrs: {
      "href": "http://www.acupressbooks.com",
      "id": "AvO",
      "target": "_blank"
    }
  }, [_vm._v("www.acupressbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0em"
    },
    attrs: {
      "id": "pz4-20"
    }
  }, [_vm._v("\n\t\t\t\t\t18   19   20   21   22   23   /   7   6   5   4   3   2   1 ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2a70f58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyrightpage.vue
// module id = 63
// module chunks = 0